<template>
  <div class="consultant-stat">
    <div class="container-backdrop  stats-bg">
      <div class="info">
        <img
          class="clock svg"
          src="../../assets/images/icon-awesome-clock.svg"
        />
        <div class="data">
          <span class="data-txt">Total Duration</span>
          <span>{{ this.sumHr }} Hr(s)</span>
        </div>
      </div>
      <div class="info">
        <img class="svg" src="../../assets/images/presentation.svg" />
        <div class="data">
          <span class="data-txt">Workshops Attended</span>
          <span>{{
            this.compWrk.filter(o => o.bools.paid || o.fee == 0).length
          }}</span>
        </div>
      </div>
      <div class="info">
        <img class="svg" src="../../assets/images/training.svg" />
        <div class="data">
          <span class="data-txt">Upcoming Workshops</span>
          <span>{{ this.pendingWrk.length }}</span>
        </div>
      </div>
      <div class="info">
        <i class="fa fa-bell fa-4x bell"></i>
        <div class="data">
          <span class="data-txt">Notification</span>
          <span>Coming soon</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stat",
  props: ["sumHr", "compWrk", "pendingWrk"]
};
</script>

<style scoped>
.container-backdrop {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  place-items: center;
  margin-bottom: 50px;
}
.consultant-stat {
  max-width: 1300px;
  margin: 0 auto;
}
.stats-bg {
  background-color: #e8ecf1;
}
.bell {
  color: #728391;
}
.data-txt {
  color: #728391;
}
.data span:last-child {
  color: #728391;
  font-family: "Open Sans";
  font-weight: 700;
}
@media only screen and (max-width: 600px) {
  .container-backdrop {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    place-items: center;
    margin-bottom: 50px;
  }
  .consultant-stat {
    max-width: 1300px;
    margin: 0 auto;
  }
  .svg {
    width: 50px;
    height: 50px;
  }
  .stats-bg {
    background-color: #e8ecf1;
    border-radius: 10px;
  }
  .bell {
    color: #728391;
  }
  .data-txt {
    color: #728391;
  }
  .data span:last-child {
    color: #728391;
    font-family: "Open Sans";
    font-weight: 700;
  }
}
</style>
